var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      title: _vm.$t(
        "label_essweb_RosterRecordForm_form_slide_dialog_selectSenderTitle"
      ),
      width: "600",
      dialog: _vm.show,
    },
    on: { close: _vm.closeDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form", attrs: { "lazy-validation": "" } },
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      [
                        _c(
                          "v-sheet",
                          { staticClass: "mrc_text_require text--secondary" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "label_essweb_RosterRecordForm_form_slide_dialog_senderLabel"
                                )
                              )
                            ),
                          ]
                        ),
                        _c("v-autocomplete", {
                          attrs: {
                            items: _vm.SenderList,
                            filled: "",
                            dense: "",
                            chips: "",
                            filter: _vm.$staffFilter,
                            "hide-details": "",
                            "deletable-chips": "",
                            "small-chips": "",
                            multiple: "",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            "single-line": "",
                            color: "primary",
                            "item-text": "staff_code",
                            "item-value": "staff_id",
                          },
                          on: {
                            input: function (val) {
                              if (val.length > 1) {
                                //2021-04-07 Daveluo 改为单选，若要多选去掉这个function
                                _vm.curSender = _vm.curSender.slice(1, 2)
                              }
                            },
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "no-data",
                              fn: function () {
                                return [_c("noContent")]
                              },
                              proxy: true,
                            },
                            {
                              key: "selection",
                              fn: function (data) {
                                return [
                                  _c(
                                    "v-chip",
                                    _vm._b(
                                      {
                                        attrs: {
                                          close: "",
                                          pill: "",
                                          "input-value": data.selected,
                                        },
                                        on: {
                                          click: data.select,
                                          "click:close": function ($event) {
                                            return _vm.removeStaff(data.item)
                                          },
                                        },
                                      },
                                      "v-chip",
                                      data.attrs,
                                      false
                                    ),
                                    [
                                      _c("StaffAvatar", {
                                        attrs: {
                                          left: "",
                                          contentClass: "white--text",
                                          src: data.item.staff_avatar,
                                          staff_name: data.item.preferred_name,
                                        },
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$getCommonLangValue(
                                              data.item.preferred_name
                                            )
                                          ) +
                                          " "
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                            {
                              key: "item",
                              fn: function (data) {
                                return [
                                  _c(
                                    "v-list",
                                    {
                                      staticClass: "pa-0",
                                      attrs: {
                                        rounded: "",
                                        width: "100%",
                                        nav: "",
                                        dense: "",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-list-item",
                                        {
                                          staticClass: "pa-0 ma-0",
                                          attrs: {
                                            rouned: "",
                                            width: "100%",
                                            nav: "",
                                            "two-line": "",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-list-item-avatar",
                                            {
                                              staticClass: "ma-0 mr-2",
                                              attrs: { size: "36" },
                                            },
                                            [
                                              _c("StaffAvatar", {
                                                attrs: {
                                                  size: "36",
                                                  src: data.item.staff_avatar,
                                                  staff_name:
                                                    data.item.preferred_name,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-list-item-content",
                                            [
                                              _c(
                                                "v-list-item-title",
                                                { staticClass: "text-body-2" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$getCommonLangValue(
                                                        data.item.preferred_name
                                                      )
                                                    ) + " "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text--secondary text-caption-xs",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          data.item.staff_code
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c("v-list-item-subtitle", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.$getCommonLangValue(
                                                      data.item.job_post_name
                                                    )
                                                  ),
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value: _vm.curSender,
                            callback: function ($$v) {
                              _vm.curSender = $$v
                            },
                            expression: "curSender",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: { submitBtn: "" },
              on: { cancel: _vm.closeDialog, submit: _vm.toSave },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }